import { createSlice } from '@reduxjs/toolkit';
import { IMdbError } from '../../../errorObjects/MdbError';

const initialState: IMdbError | null = null;

export const videoLinkDeleteFailureSlice = createSlice({
  name: 'videoLinkDeleteFailure',
  initialState,
  reducers: {
    // action has a payload with an error
    videoLinkDeleteFailureChange(state, action) {
      return action.payload;
    },
        
    // action has a payload with a null value
    videoLinkDeleteFailureClear(state) {
      return null;
    },
  },
})

// Action creators are generated for each function in reducer)
export const { videoLinkDeleteFailureChange, videoLinkDeleteFailureClear } = videoLinkDeleteFailureSlice.actions;

// export the core reducer for the slice
export const videoLinkDeleteFailureReducer = videoLinkDeleteFailureSlice.reducer;

export default videoLinkDeleteFailureSlice.reducer;